import { useState } from 'react';

import { useWoosmapScript } from '@spotahome/marketplace-common/src/utils/woosmap-script';

import InteractiveMap from './InteractiveMap.woosmap';

const InteractiveMapContainer = props => {
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  useWoosmapScript(() => setIsMapLoaded(true));

  return isMapLoaded ? <InteractiveMap {...props} /> : null;
};

export default InteractiveMapContainer;
